import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorInstancesByProcessorQuery,
  GetProcessorInstancesByProcessorQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSOR_INSTANCES_BY_PROCESSOR: TypedDocumentNode<
  GetProcessorInstancesByProcessorQuery,
  GetProcessorInstancesByProcessorQueryVariables
> = gql`
  query GetProcessorInstancesByProcessor($processorId: String!, $limit: Int) {
    processorInstances(processorId: $processorId, limit: $limit) {
      id
      processorId
      userId
      status
      metadata
      error
      createdAt
      updatedAt
    }
  }
`;
